/* istanbul ignore file */
import { Container } from 'inversify';
export const container = new Container({
    defaultScope: 'Singleton',
    autobind: true,
});
export function inject(identifier, injectContainer = container) {
    return injectContainer.get(identifier);
}
